/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Details_TitleInputs */

const en_campaigns_mag7_details_title = /** @type {(inputs: Campaigns_Mag7_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to participate`)
};

const de_campaigns_mag7_details_title = /** @type {(inputs: Campaigns_Mag7_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So nehmen Sie teil`)
};

const pt_br2_campaigns_mag7_details_title = /** @type {(inputs: Campaigns_Mag7_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como participar`)
};

const tr_campaigns_mag7_details_title = /** @type {(inputs: Campaigns_Mag7_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasıl katılabilirsiniz`)
};

const zh_cn2_campaigns_mag7_details_title = /** @type {(inputs: Campaigns_Mag7_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参与方式`)
};

const zh_hk2_campaigns_mag7_details_title = /** @type {(inputs: Campaigns_Mag7_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`參加方法`)
};

const ko_kr2_campaigns_mag7_details_title = /** @type {(inputs: Campaigns_Mag7_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`참여 방법`)
};

const ru_ru2_campaigns_mag7_details_title = /** @type {(inputs: Campaigns_Mag7_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как участвовать`)
};

const es_419_campaigns_mag7_details_title = /** @type {(inputs: Campaigns_Mag7_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo participar`)
};

/**
* | output |
* | --- |
* | "How to participate" |
*
* @param {Campaigns_Mag7_Details_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_details_title = /** @type {((inputs?: Campaigns_Mag7_Details_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Details_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_details_title(inputs)
	if (locale === "de") return de_campaigns_mag7_details_title(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_details_title(inputs)
	if (locale === "tr") return tr_campaigns_mag7_details_title(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_details_title(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_details_title(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_details_title(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_details_title(inputs)
	return es_419_campaigns_mag7_details_title(inputs)
});